import React, { useLayoutEffect } from "react";
import { BrookshireBrotherLogoWithTagline, GroupLifeInsuranceBrochure } from "../../../../../assets";
import CoreGroupLifeImage from "../../../../../assets/CorePlanImages/CoreGroupLifeImage.avif";
import "./grouplifeinsurance.scss";
import BrochureRenderer from "../../../../shared/brochureRenderer/BrochureRenderer";

const GroupLifeInsurance: React.FC = (): JSX.Element => {
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});
	return (
		<div className="Grouplife-card-main-container">
			<div className="main-landing-container">
				<div className="left-section">
					<h3 className="main-benefits-title">GroupLife Insurance Plan</h3>
					<div className="powered-by-logo-container">
						<span>Powered By</span>
						<img src={BrookshireBrotherLogoWithTagline} alt="" />
					</div>
					<div className="plan-description">
						<span>
							Designated full-time employees are automatically enrolled in company-paid life coverage.
							This benefit is non-contributory to the employee and the death benefit is one times the
							employee’s annual salary. PLEASE COMPLETE A BENEFICIARY FORM. A beneficiary designation is
							VITAL to ensure that your benefits are paid accordingly on your behalf.
						</span>
					</div>
				</div>
				<div className="right-section">
					<img src={CoreGroupLifeImage} alt="Core Group life insurance image" />
				</div>
			</div>
			<h3 className="sub-heading-title">Plan Brochure</h3>

			<div className="brochure-renderer-container" style={{ overflow: "hidden" }}>
				<BrochureRenderer brochure={GroupLifeInsuranceBrochure} />
			</div>
		</div>
	);
};

export default GroupLifeInsurance;
